import React from 'react'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import { required, ModalContext, useHandler, Form } from 'labguard-cdk'
import { useQuery, useMutation } from 'react-apollo'
import ChannelAlarmModal from './ChannelAlarmModal'

const query = gql`
  query channelAlarmModal($alarmId: ID!) {
    alarm(id: $alarmId) {
      id
      startDate
      endDate
      type {
        id
        key
        color @client
        i18n @client
        criticality
      }
      ackUser {
        id
        firstname
        lastname
      }
      ackDate
      ackComment {
        id
        label
      }
    }
  }
`

const mutation = gql`
  mutation acknowledgeAlarm($alarmId: ID!, $ackCommentId: ID, $alertComment: String) {
    acknowledgeAlarm(alarmId: $alarmId, ackCommentId: $ackCommentId, alertComment: $alertComment) {
      id
      toBeAcknowledged
      ackDate
      ackUser {
        id
        firstname
        lastname
      }
      ackComment {
        id
        label
      }
      alertComments {
        date
        username
        comment
      }
      nbComments
      # update all the groups relative to the channel
      channel {
        id
        groups {
          id
          nbChannelsWithAlarm
          criticalities
          colors @client
          winkingAlarm {
            id
          }
        }
        criticalities
        colors @client
        winkingAlarm {
          id
        }
      }
    }
  }
`

export default function ChannelAlarmModalContainer({ alarmId }) {
  // get alarm initial data
  const { loading, data: { alarm = {} } = {} } = useQuery(query, {
    variables: { alarmId },
    fetchPolicy: 'network-only',
  })

  const initialValues = React.useMemo(() => ({ alertComment: alarm.alertComment || '' }), [alarm])

  // get acknowledgement mutation
  const [acknowledgeAlarm] = useMutation(mutation)

  // get close modal handler
  const { close } = ModalContext.use()

  // create submit handler
  const onSubmit = useHandler(values => acknowledgeAlarm({ variables: { alarmId, ...values } }).then(close))

  // create validation handler
  const validate = useHandler(({ alertComment, ackCommentId }) => ({
    ackCommentId: !alarm.ackComment && required(ackCommentId),
    alertComment: !!alarm.ackComment && required(alertComment),
  }))

  return (
    <Form initialValues={initialValues} onSubmit={onSubmit} validate={validate}>
      <ChannelAlarmModal alarm={alarm} loading={loading} />
    </Form>
  )
}

ChannelAlarmModalContainer.propTypes = {
  alarmId: PropTypes.string,
}
